import React from "react";
import LangSvg from "../../images/languages";
import userData from "../../userdata.json";
import LottieAnimation from "../loties-animation";
function About() {
  const { wdid, about } = userData || {};
  return (
    <div id="About" className="pt6">
      <div className=" f1 flex">
        <hr className="w-50" />
        <span className="mh3">About</span>
        <hr className="w-50" />
      </div>
      <div className="mt4">
        <div className="flex mt4 justify-between items-center flex-column-reverse  flex-row-l ">
          <div className="w-50-l flex-shrink-0  ">
            <LottieAnimation name="one" />
          </div>
          <div className="w-50-l pv4">
            <i className="f3">
              <q className="roboto b">{about?.quote || null}</q>
            </i>
            <div className="f4 mt4 lh-title"> &nbsp;  &nbsp;  &nbsp;&nbsp;  &nbsp;  &nbsp; {about?.about || ""}</div>
          </div>
        </div>
        <div className="  mt4 fw9">
          <div className="f2  text-align-center">What do I do?</div>
          <div className="f3 mt3  text-align-center">
            Explores frontend technologies, and having edge to learn and perform better.
          </div>
          <div className="flex mt4 items-center w-100 flex-column-reverse flex-row-l">
            <div className="w-50-l pt4">
              <div className="f2  text-align-center">
                Front-end Development
              </div>
              <div className="flex  items-center justify-center mt4">
                {(wdid?.langs || []).map((lang, index) => (
                  <div
                    key={index}
                    className="glassmorphic-2 ba pa2 br-100 grayscale-100  langs  pointer mr2"
                  >
                    <LangSvg lang={lang} className="w2 h2 " />
                  </div>
                ))}
              </div>
              <ul className="f4 mt4" type="circle">
                <li className="mt3">
                  Building Single Page Applications in React/Next.js
                </li>
                <li className="mt3">
                  Rich UI pages for better user experice in React/Next.js.
                </li>
                <li className="mt3">
                  Learning and implementing performance optimizations, and web securities.
                </li>
                
              </ul>
            </div>
            <div className=" w-50-l   flex-shrink-0">
              <LottieAnimation name="two" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
